export const REQUEST_REJECTED_CLAIMS: string = 'REQUEST_REJECTED_CLAIMS';
export const SET_REJECTED_CLAIMS: string = 'SET_REJECTED_CLAIMS';
export const SEARCH_QUERY_INIT_VALUES = {
  lossDate: null,
  registrationNumber: null,
  claimNumber: null,
};
export const SEARCH_TYPE_IDS = {
  REGISTRATION_NUMBER: 'REGISTER',
  LOSS_DATE: 'LOSS_DATE',
  PRE_OPEN_DATE: 'PRE_OPEN_DATE',
  CLAIM: 'CLAIM',
};
